<script>
import $ from 'jquery'
import setting from '@/setting.js'

export default {
    props: ['ball', 'mode', 'allBalls', 'baseBallIndex', 'savedBalls', 'currentAngle', 'slideBatx', 'slideBaty', 'slideBatz', 'slidePitx', 'slidePity', 'slidePitz', 'currentBatterPointSet', 'batterPanelState', 'pitcherPanelState', 'savedStandardBall', 'base', 'compar', 'PTReviewStandardBall', 'threeListSortMode'],
    emits: ['change-pitcher-position', 'change-pitcher-point', 'submit-pitcher-point', 'close-pitcher-panel', 'submit-pitcher-position'],
    data() {
        return {
            setting,
            slideParamsx1: 0,
            slideParamsy1: 0,
            slideParamsz1: 0,
            slideParamsx2: 0,
            slideParamsy2: 0,
            slideParamsz2: 0,
            defaultParamsx1: 0,
            defaultParamsy1: 0,
            defaultParamsz1: 0,
            defaultParamsx2: 0,
            defaultParamsy2: 0,
            defaultParamsz2: 0,
            currentParamsx: 0,
            currentParamsz: 0,
            currentParamsy: 0,
            currentParamsx2: 0,
            currentParamsy2: 0,
            inputParamsx: 0,
            inputParamsz: 0,
            inputParamsy: 0,
            inputParamsx2: 0,
            inputParamsy2: 0,
            leftRightPitcherFlg: false,
            inputDefaultParamsx: 0,
            inputDefaultParamsz: 0,
            inputDefaultParamsy: 0,
            inputDefaultParamsx2: 0,
            inputDefaultParamsy2: 0,
            defaultBeforeAfterFlg: false,
            defaultLeftRightFlg: false,
            defaultLeftRightPitcherFlg: false,
            pitcherInputState: 0,
            pitcherPositionIsValid: false,
            pitcherPointIsValid: false
        }
    },
    watch: {
        slideParamsx2: 'changePitcherPosition',
        slideParamsy2: 'changePitcherPoint',
        currentAngle: 'changeSlideParams',
        leftRightPitcherFlg: 'pitcherPositionValid'
    },
    mounted() {
        this.changeSlideParams()
    },
    methods: {
        changePitcherPosition: function () {
            this.currentParamsx2 = this.slideParamsx2
            this.$emit('change-pitcher-position', -1 * this.slideParamsx2)
        },
        changePitcherPoint: function () {
            this.currentParamsy2 = this.slideParamsy2
            this.$emit('change-pitcher-point', this.slideParamsy2)
        },
        changeSlideParams: function () {
            this.slideParamsx1 = this.slideBatx
            this.slideParamsy1 = this.slideBaty
            this.slideParamsz1 = this.slideBatz
            this.slideParamsx2 = this.slidePitx
            this.slideParamsy2 = this.slidePity
            this.slideParamsz2 = this.slidePitz
            this.defaultParamsx1 = this.slideBatx
            this.defaultParamsy1 = this.slideBaty
            this.defaultParamsz1 = this.slideBatz
            this.defaultParamsx2 = this.slidePitx
            this.defaultParamsy2 = this.slidePity
            this.defaultParamsz2 = this.slidePitz
        },
        formatPitParams: function (num) {
            if (num < 0) {
                return '左 ' + Math.abs(num)
            } else if (num > 0) {
                return '右 ' + Math.abs(num)
            } else {
                return num
            }
        },
        closePitcherPanel: function () {
            this.$emit('close-pitcher-panel')
        },
        toggleLeftRightPitcherFlg: function (bool) {
            this.leftRightPitcherFlg = bool
        },
        changePitcherInputState: function (num) {
            if (num === 1) {
                this.leftRightPitcherFlg = this.currentParamsx2 < 0
                this.inputParamsx2 = Math.abs(this.currentParamsx2)
                this.inputDefaultParamsx2 = this.inputParamsx2
                this.defaultLeftRightPitcherFlg = this.leftRightPitcherFlg
            } else if (num === 2) {
                this.inputParamsy2 = this.currentParamsy2
                this.inputDefaultParamsy2 = this.inputParamsy2
            }
            this.pitcherInputState = num
        },
        validPitcherParamsx: function (e, val) {
            if (val !== 0 && !val) {
                this.inputParamsx2 = 0
            } else if (val < 0) {
                this.inputParamsx2 = 0
            }
            this.pitcherPositionValid()
        },
        validPitcherParamsy: function (e, val) {
            if (val !== 0 && !val) {
                this.inputParamsy2 = 160
            }
            this.pitcherPointValid()
        },
        pitcherPositionValid: function () {
            let validCount = 0
            let valid = false
            if (this.leftRightPitcherFlg) {
                if (this.inputParamsx2 > 30) {
                    validCount++
                }
            } else if (!this.leftRightPitcherFlg) {
                if (this.inputParamsx2 > 30) {
                    validCount++
                }
            }
            if (validCount > 0) {
                valid = true
            }
            this.pitcherPositionIsValid = valid
        },
        pitcherPointValid: function () {
            let validCount = 0
            let valid = false
            if (this.inputParamsy2 > 200) {
                validCount++
            } else if (this.inputParamsy2 < 160) {
                validCount++
            }
            if (validCount > 0) {
                valid = true
            }
            this.pitcherPointIsValid = valid
        },
        submitPitcherPosition: function () {
            let x = this.inputParamsx2
            x = this.leftRightPitcherFlg ? -1 * x : x
            this.$emit('submit-pitcher-position', this.defaultParamsx2 + x)
            this.currentParamsx2 = x
            this.slideParamsx2 = x
            this.changePitcherInputState(0)
        },
        submitPitcherPoint: function () {
            let y = this.inputParamsy2
            this.$emit('submit-pitcher-point', y)
            this.currentParamsy2 = y
            this.slideParamsy2 = y
            this.changePitcherInputState(0)
        },
        resetPitcherPosition: function () {
            this.inputParamsx2 = this.inputDefaultParamsx2
            this.leftRightPitcherFlg = this.defaultLeftRightPitcherFlg
        },
        resetPitcherPoint: function () {
            this.inputParamsy2 = this.inputDefaultParamsy2
        },
        blurAfter: function () {
            $('body').scrollTop(0)
        }
    }
}
</script>
